module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-center exclusive-bar",
    style: ([_vm.showExcStyle])
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('div', {
    staticClass: "customcheckbox mr-15 pointer",
    staticStyle: {
      "text-transform": "unset"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "giftwrap",
      "id": "giftwrap"
    },
    domProps: {
      "checked": _vm.checkedExcBox
    },
    on: {
      "click": function($event) {
        _vm.addExclusiveToCartFromBand(_vm.EXCLUSIVE_PRODUCTS[2].prod_id)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mb0",
    attrs: {
      "for": ""
    }
  }, [_vm._v(_vm._s(_vm.excBannerMsg))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a6a7843"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/ExcBand.vue
// module id = 2531
// module chunks = 13